import { useRef, RefObject } from "react"

interface Focusable {
  focus: () => void
}

type Retorno<T> = [RefObject<T>, () => void]

export const useFocus = <T extends Focusable> (): Retorno<T> => {
  const ref = useRef<T>(null);
  const setFocus = () => ref.current && ref.current?.focus();

  return [ref, setFocus] 
}